module.exports = __webpack_public_path__ + "media/images/booknow-img2-ea2afedf894c6878065a1e2bc25bac12.png";